module.exports = __webpack_public_path__ + "static/img/image-3.a8ff664.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image-3.jpg
// module id = 147
// module chunks = 1